import React, { useState } from "react";
import { authenticationService } from "../../services/AuthinticationService";
import { useNavigate } from "react-router-dom";
import { TextInput } from "../../components/input/TextInput";
import { FormBuilder } from "../../components/forms/FormBuilder";
import { Error } from "../../components/forms/Error";
import formData from "../../components/forms/formsData.json";
export function ResetPassword() {
  const PasswordDontMatchException = "The passwords do not match";
  const PasswordRequirementException =
    "The password you entered doesn’t meet the minimum security requirements";

  const [newPasswordInputs, setNewPasswordInputs] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });

  const [isError, setIsError] = useState(null);
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [formType, setFormType] = useState(formData["newPassword"]);
  const [isLoading, setIsLoading] = useState(true);
  const [showPassword, setShowPassword] = useState({
    newPassword: false,
    confirmNewPassword: false,
  });
  const [BackendErrors, setBackendErrors] = useState(null);
  const [errRegexObj, setErrRegexObj] = useState({});

  const SubmitFunc = async () => {
    let userID = sessionStorage.getItem("userID");

    if (Object.keys(errRegexObj).length > 0) {
      setIsError(PasswordRequirementException);
      return;
    }

    if (
      newPasswordInputs.newPassword !== newPasswordInputs.confirmNewPassword
    ) {
      setIsError(PasswordDontMatchException);
      return;
    }

    try {
      setIsLoading(true);
      let response = await authenticationService.changeNewPassword(
        newPasswordInputs,
        userID
      );

      console.log(response);

      if (response.status < 400) {
        let data = response.data;
        if (
          data &&
          data.hasOwnProperty("status") &&
          String(data["status"]).toLowerCase() === "pass"
        ) {
          let role = data.profile.Role;
          const route = role ? role : "";

          if (role === "Call Center") navigate(`/${route}/DeviceManagement`);
          else if (role === "Radiologist") navigate(`/${route}`);
          else navigate(`/${route}/Dashboard`);
        }
      }
    } catch (err) {
      // Axios puts the backend response in err.response.data
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Unexpected error";
      setBackendErrors(message); // ✅ will now show "Password must not contain username"
    } finally {
      setIsLoading(false);
    }
  };

  const passwordValidation = (password) => {
    let lengthPattern = /^.{8,20}$/;
    let specialCharacterPattern =
      /^(?=.*[!@#$%^&*()_\-+={}[\]\\|:;"'<>,.?\/]).*$/;
    let oneNumberPattern = /^(?=.*\d).*$/;
    let upperCasePattern = /^(?=.*[A-Z]).*$/;
    let lowerCasePattern = /^(?=.*[a-z]).*$/;

    let errObj = {};

    if (!lengthPattern.test(password)) {
      errObj["1"] = true;
    }
    if (!specialCharacterPattern.test(password)) {
      errObj["2"] = true;
    }
    if (!oneNumberPattern.test(password)) {
      errObj["3"] = true;
    }
    if (!upperCasePattern.test(password)) {
      errObj["4"] = true;
    }
    if (!lowerCasePattern.test(password)) {
      errObj["5"] = true;
    }
    const isValidationError = Object.keys(errObj).length > 0;
    setIsError(null);
    setErrRegexObj(errObj);
  };
  const handleChange = async (event) => {
    let inputs = { ...newPasswordInputs };
    let name = event.target.name;
    let value = event.target.value;
    inputs[name] = event.target.value;
    let form = [...formType];
    let formErrors = { ...error };
    switch (name) {
      case "newPassword":
        passwordValidation(value);
        if (isError) {
          formErrors["newPassword"] = true;
        } else if (!value) {
          form[0]["error"] = "Please enter password";
          formErrors["newPassword"] = true;
          setIsError(true);
        } else {
          formErrors["newPassword"] = false;
          // setIsError(false)
          form[0]["error"] = "";
        }
        break;
      default:
        value = event.target.value;
    }
    inputs[name] = value;
    setNewPasswordInputs(inputs);
    setBackendErrors(null);
    setFormType(form);
    setError(formErrors);
  };
  const setShowPasswordType = (name) => {
    const showPasswordObj = Object.assign({}, showPassword);
    showPasswordObj[name] = !showPassword[name];
    setShowPassword(showPasswordObj);
  };
  return (
    <div className="p-[70px_38.5px_0px_38.5px] rounded-[32px] flex flex-col justify-self-center items-center self-center justify-start w-login h-login bg-gray-800-opacity-30 bg-blend-luminosity border-gradient-custom">
      {/* <SVGraphics className={'flex min-w-[23rem] min-h-[3.75rem] self-center'}
                        svgname={'verticaPlus'} fill={'none'}/> */}

      <div>
        <div className={"flex-col flex items-center"}>
          <TextInput
            text={"Reset password"}
            className={"text-white text-3xl leading-tight"}
          />
          <TextInput
            text={"Set a new password below."}
            className={
              " text-white text-opacity-50 leading-trim text-base leading-normal"
            }
          />
        </div>

        <div className={"flex flex-col items-center w-full p-0"}>
          <FormBuilder
            data={formType}
            formData={newPasswordInputs}
            onChange={(e) => handleChange(e)}
            containerClassName={"flex-col flex w-full h-full items-center z-10"}
            inputClassName="custom-input rounded-[10px] h-[56px] w-[429px] z-20 font-normal font-Inter text-white placeholder-white"
            isShown={error}
            type={showPassword}
            disableErrorMessage={true}
            showOnClick={(e) => setShowPasswordType(e)}
            isError={isError}
          />
        </div>

        <div className={"mt-2 w-96"}>
          <Error message={isError} isShown={isError} />
        </div>

        <div
          className={
            "flex-col w-100 text-[13px] text-regularGrey flex flex-wrap mt-[15px]"
          }>
          <p>
            Password must be at least
            <span style={{ color: errRegexObj["1"] ? "red" : "#757575" }}>
              {" "}
              8–20 characters
            </span>
            and must contain at least a
            <span style={{ color: errRegexObj["4"] ? "red" : "#757575" }}>
              {" "}
              Capital letter
            </span>
            , a
            <span style={{ color: errRegexObj["5"] ? "red" : "#757575" }}>
              {" "}
              Lowercase letter
            </span>
            , a
            <span style={{ color: errRegexObj["3"] ? "red" : "#757575" }}>
              {" "}
              Number
            </span>{" "}
            and a
            <span style={{ color: errRegexObj["2"] ? "red" : "#757575" }}>
              {" "}
              Special character
            </span>
            .
          </p>

          <div className="password-requirements flex">
            {/* <ul>
                           
                            <li style={{width:'9.813rem',height:'0.438rem',fontSize:'10px',fontHeight:'15px',color: errRegexObj['2'] ? 'red' : '#999996'}}>One special character</li>
                            <li style={{width:'9.813rem',height:'0.438rem',fontSize:'10px',fontHeight:'15px',color: errRegexObj['3'] ? 'red' : '#999996'}}>One number</li>
                        </ul>
                        <ul style={{marginLeft:'1.375rem'}}>
                            <li style={{width:'9.813rem',height:'0.438rem',fontSize:'10px',fontHeight:'15px',color: errRegexObj['4'] ? 'red' : '#999996'}}>One uppercase character</li>
                            <li style={{width:'9.813rem',height:'0.438rem',fontSize:'10px',fontHeight:'15px',color: errRegexObj['5'] ? 'red' : '#999996'}}>One lowercase character</li>
                        </ul> */}
          </div>
        </div>
      </div>

      <div className={"mt-[.938rem] z-10"}>
        <button
          type="button"
          onClick={() => SubmitFunc()}
          // disabled={!LoginInputs['Email'] || !LoginInputs['Password'] || (LoginInputs['Email'] && !utils.mailValidation(LoginInputs['Email']))}
          className="rounded-[10px] button-glow flex w-[429px] h-[56px] justify-center items-center flex-shrink-0 text-white text-lg font-[500] text-[16px]">
          Reset
        </button>
      </div>

      <div
        className={"mt-[0.75rem] text-white z-10"}
        onClick={() => navigate("/login")}>
        Back to
        <span
          className="
        text-[#0099FF] underline
        cursor-pointer
        pl-1
        "
          onClick={() => navigate("/")}>
          Login
        </span>
      </div>

      <div className={"w-full text-left mt-2 ml-24"}>
        <Error message={BackendErrors} isShown={BackendErrors} />
      </div>
    </div>
  );
}
